import { render, staticRenderFns } from "./sso-saml.vue?vue&type=template&id=76dd4a9b&"
import script from "./sso-saml.ts?vue&type=script&lang=ts&"
export * from "./sso-saml.ts?vue&type=script&lang=ts&"
import style0 from "./sso-saml.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports